import { render } from "./competitors-list.vue?vue&type=template&id=a4e5b420&scoped=true&lang=pug"
import script from "./competitors-list.vue?vue&type=script&lang=js"
export * from "./competitors-list.vue?vue&type=script&lang=js"

import "./competitors-list.vue?vue&type=style&index=0&id=a4e5b420&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e5b420"]])

export default __exports__